import React from "react"
import moment from "moment-timezone"
import { addDays } from "./plannerCalendar"
import { daysLabel, plural } from "./plannerLabels"
import PlannerDialog from "./PlannerDialog"
import WarningRow from "./WarningRow"

// "Move a confirmed proposal?" (ticket 15 Q4, ticket 16): the organizer confirmed these dates, so moving it returns it to Proposed and
// it needs a new confirmation. The move still waits 7 s with Undo once confirmed here. The page gives the proposal as the calendar
// reads it now, and `newDates`, the warnings it would have there (ticket 13 place 6, Phase C1w: { status, warnings } or null while
// unread), listed with the quick peek's rows; they never stop the move.
export default function MoveDialog({ item, delta, timeZone, newDates, onClose, onConfirm }) {
  const to = { start: addDays(item.days.start, delta), end: addDays(item.days.end, delta) }
  const confirmedOn = item.answer?.at ? ` on ${moment(item.answer.at).tz(timeZone).format("D MMM YYYY")}` : ""
  return <PlannerDialog title="Move a confirmed proposal?" onClose={onClose}
    actions={<button type="button" className="btn btn-primary" onClick={onConfirm}>Move and return to Proposed</button>}>
    <p>{`${item.organizer?.companyName || "The organizer"} confirmed ${item.number} for ${daysLabel(item.days)}${confirmedOn}. Moving it to `
      + `${daysLabel(to)} returns it to Proposed. It will need a new confirmation.`}</p>
    <NewDatesWarnings answer={newDates} timeZone={timeZone} />
  </PlannerDialog>
}

// The warnings at the new dates: a proposal's own, or, for a published event, those its unpublished neighbours would carry with it there
// (`neighbours`, Phase E3; the rows name the neighbour).
export function NewDatesWarnings({ answer, timeZone, neighbours = false }) {
  const whose = neighbours ? " for its neighbours" : ""
  if (answer?.status === "failed") {
    return <p className="ep-meta mb-0">{`The warnings${whose} at the new dates could not be checked. You can still move it.`}</p>
  }
  if (answer?.status !== "ready") return <p className="ep-meta mb-0">{`Checking the warnings${whose} at the new dates…`}</p>
  if (!answer.warnings.length) return <p className="ep-meta mb-0">{`No warnings${whose} at the new dates.`}</p>
  const open = answer.warnings.filter(warning => warning.open).length
  return <section className="ep-move-warnings" aria-label={`Warnings${whose} at the new dates`}>
    <b>{open ? `${plural(open, "warning")}${whose} at the new dates` : `No open warnings${whose} at the new dates`}</b>
    {answer.warnings.map(warning => <WarningRow key={warning.key} warning={warning} timeZone={timeZone} />)}
  </section>
}
